import type { JobDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { DRAFT } from '../types/types';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { refreshJobDTOAtom } from '../atoms/refreshJobDTOAtom';

export const jobDtoSelector = selector<JobDTO>({
    key: 'getJobDto',
    get: async ({ get }) => {
        const { jobNumber } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        get(refreshJobDTOAtom);
        if (!isLoggedOn) {
            return { jobStatus: DRAFT, selectedPaymentFrequency: 'monthly' };
        }
        const res = await OnlineSales.getJobDTO(jobNumber);
        return res;
    }
});
